import ProductSize from './product-size';
import GenericModel from '../generic-model';
import Employee from './employee';
import ProductCompanyPMSColor from './product-company-pmscolor';
import ProductAsset from '../product-asset';
import ProductPlacement from '../product/product-placement';
import HeightEquipment from '../height-equipment';
import RequestedProductSize from './requested-product-size';
import { SoldRented } from '../project/sold-rented';
import { Repo } from '../project/repo';
import ProductPhoneNumber from './product-phone-number';
import LoggedAction from '../logged-action';
import LineWithHeaderFinished from '../../display-model/line-with-header-finished';

export default class Product extends GenericModel {
  type?: string;
  productSize?: ProductSize;
  newDesign?: boolean;
  layoutDescription?: string;
  generalExtraInfo?: string;
  title?: string;
  titleCheckedDesign?: boolean;
  titleCheckedDesignRegistration?: LoggedAction;
  phoneNumberCheckedDesign?: boolean;
  phoneNumberCheckedDesignRegistration?: LoggedAction;
  titleCheckedPrintWork?: boolean;
  titleCheckedPrintWorkRegistration?: LoggedAction;

  ipBoardCheckedPrintWork?: boolean;
  phoneNumberCheckedPrintWork?: boolean;
  textPrintworkChecked?: boolean;
  extraBoardCheckedPrintWork?: boolean;
  stickerCheckedPrintWork?: boolean;
  arrowCheckedPrintWork?: boolean;
  secondBoardCheckedPrintWork?: boolean;
  otherOrderCheckedPrintWork?: boolean;
  atelierCheckedPrintWork?: boolean;

  phoneNumbers?: string[];
  otherPhone?: string;
  text?: string;
  materialDisplayName?: string;
  extraAttentionFinish?: boolean;
  extraAttentionFinishDescription?: string;
  spellCheck?: boolean;
  spellCheckRegistration?: LoggedAction;
  designASAP?: boolean;
  designByDate?: Date;
  designerHourBudget?: number;
  designerMinuteBudget?: number;
  designer?: Employee;
  designerNotes?: string;
  designFinished?: boolean;
  emailText?: string;
  customerDisapproves?: boolean;
  customerDisapprovalFeedback?: string;
  customerDisapprovalAction?: string;
  customerApproves?: boolean;
  customerApprovalFeedback?: string;
  approvedBy?: string;
  printByMutoh?: boolean;
  printByAgfa?: boolean;
  needPrintwork?: boolean;
  printworkExtraInfo?: string;
  atelierExtraInfo?: string;
  printworkASAP?: boolean;
  printworkByDate?: Date;
  printworkHandler?: Employee;
  printOperatorNotes?: string;
  printworkFollowUp?: string;
  printWorkReady?: boolean;
  needFinish?: boolean;
  finishDescription?: string;
  finishASAP?: boolean;
  finishByDate?: Date;
  finisher?: Employee;
  finisherHourBudget?: number;
  finisherMinuteBudget?: number;
  inpressLogo?: boolean;
  immoscoopLogo?: boolean;
  spottoLogo?: boolean;
  productCompanyPMSColors?: ProductCompanyPMSColor[];
  productAssets?: ProductAsset[];
  productPlacement?: ProductPlacement;
  requestedProductSize?: RequestedProductSize;
  soldRented?: SoldRented;
  repo?: Repo;
  needsInvoice?: boolean;
  needsDesign?: boolean;
  needsDesignDescription?: string;
  printAndFinishPlanned?: boolean;
  noPrintworkExtraInfo?: string;
  finisherNotes?: string;
  finishFollowUp?: string;
  finishReady?: boolean;
  approvalDate?: Date;
  readyToInvoice?: boolean;
  productPhoneNumbers?: ProductPhoneNumber[];
  designSentToCustomer?: boolean;
  designSentLog?: LoggedAction;
  designApprovalRegistration?: LoggedAction;
  printWorkReadyRegistration?: LoggedAction;
  finishReadyRegistration?: LoggedAction;
  overviewFormat?: string;
  overviewPlacementDetail?: string;
  boardPartBoardTypeDisplay?: string;
  boardPartPlacementTypeDisplay?: string;
  boardPartDivergentBoardTypeDisplay?: string;

  // Only for display in project table
  designBackgroundClass?: string;
  designBadgeIcon?: any;
  printJobBackgroundClass?: string;
  printJobBadgeIcon?: any;
  finishBackgroundClass?: string;
  finishBadgeIcon?: any;
  placementBackgroundClass?: string;
  placementBadgeIcon?: any;
  firstPlacerDisplay?: Employee;
  boardType?: string;
  placementType?: string;
  externalSupplierLines?: LineWithHeaderFinished[];
  externalSupplierEmployees?: Employee[];
  externalSupplierDeadlines?: Date[];

  // Only for display in client corner map
  displayType?: string;
  size?: string;
  clientCornerDisplay?: string;
  clientCornerTitle?: string;

  // Only for display in placer tour list
  typeAndMeasurements?: string;
  titleDisplay?: string;
  hasTitleAdjustment?: boolean;
  hasSecondBoard?: boolean;

  constructor() {
    super();
  }

  public canSubmitAsClient(): boolean {
    return true;
  }
}

export const HEIGHT_EQUIPMENT_OPTIONS = [
  new HeightEquipment('Geen'),
  new HeightEquipment('Trapladder'),
  new HeightEquipment('Tweedelige ladder'),
  new HeightEquipment('Stelling (3,80 m)'),
  new HeightEquipment('Stelling (5,50 m)'),
  new HeightEquipment('Hoogwerker'),
];
